/* Actions */
export const GET_REQUEST = "GET_REQUEST";
export const GET_IMPORT_HISTORY_REQUEST = "GET_IMPORT_HISTORY_REQUEST";
export const POST_REQUEST = "POST_REQUEST";
